import React from 'react';
import { DollarOutlined } from '@ant-design/icons';
import MetricCard from '../../common/metricCard/MetricCard';
import StatusPill from './StatusPill';
import BasedOnMetric from './BasedOnMetric';
import { formatCompactCurrency, formatCompactNumber } from '../../../utils/numbers';
import styles from './styles/fundingRecommendationCard.module.scss';

/**
 * Top-right card on the Cashflow Management screen. Pure presentational —
 * composes the shared `MetricCard` for the icon + title block ("FUNDING
 * RECOMMENDATION" / "$1.5M - $2M"), drops the `StatusPill` into the
 * action slot so it floats top-right alongside the title row, and uses
 * the body for the BASED ON metrics group.
 */
function FundingRecommendationCard({ data }) {
    const status = data?.status;
    const min = data?.suggestedMin;
    const max = data?.suggestedMax;
    const activeUsers = data?.activeUsers;
    const advanceVolume = data?.advanceVolume;
    const incomingFunds = data?.incomingFunds;

    const range = `${formatCompactCurrency(min)} - ${formatCompactCurrency(max)}`;

    return (
        <MetricCard
            image={<DollarOutlined />}
            title={{ label: 'Funding Recommendation', description: range }}
            action={<StatusPill status={status} />}>
            <div className={styles.basedOn}>
                <span className={styles.basedOnLabel}>Based on</span>
                <div className={styles.metrics}>
                    <BasedOnMetric value={formatCompactNumber(activeUsers)} label="Active Users" />
                    <BasedOnMetric value={formatCompactCurrency(advanceVolume)} label="Advance Vol" />
                    <BasedOnMetric value={formatCompactCurrency(incomingFunds)} label="Incoming Funds" />
                </div>
            </div>
        </MetricCard>
    );
}

export default FundingRecommendationCard;
